var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Page", { attrs: { title: _vm.title } }, [
    _c(
      "div",
      { staticClass: "activeApply active edit" },
      [
        _c(
          "van-cell-group",
          {},
          [
            _c(
              "van-cell",
              {
                attrs: {
                  title: "客户名称",
                  "title-class": "van-cell--required"
                }
              },
              [
                _c("van-field", {
                  staticClass: "item2",
                  attrs: { placeholder: "请输入客户名称" },
                  model: {
                    value: _vm.traffic.customerName,
                    callback: function($$v) {
                      _vm.$set(_vm.traffic, "customerName", $$v)
                    },
                    expression: "traffic.customerName"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "van-cell",
              { attrs: { title: "客户电话" } },
              [
                _c("van-field", {
                  staticClass: "item2",
                  attrs: { placeholder: "请输入客户电话", type: "tel" },
                  model: {
                    value: _vm.traffic.phone,
                    callback: function($$v) {
                      _vm.$set(_vm.traffic, "phone", $$v)
                    },
                    expression: "traffic.phone"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "van-cell",
              {
                attrs: {
                  title: "客户性别",
                  "title-class": "van-cell--required"
                }
              },
              [
                _c(
                  "van-field",
                  {
                    staticClass: "item2",
                    attrs: { placeholder: "请选择性别", readonly: "" },
                    on: {
                      click: function() {
                        return (_vm.selectGender = true)
                      }
                    },
                    model: {
                      value: _vm.traffic.gender,
                      callback: function($$v) {
                        _vm.$set(_vm.traffic, "gender", $$v)
                      },
                      expression: "traffic.gender"
                    }
                  },
                  [
                    _c("img", {
                      staticClass: "uparrow",
                      attrs: {
                        slot: "right-icon",
                        src: require("@/assets/img/uparrow.png"),
                        alt: "",
                        srcset: ""
                      },
                      slot: "right-icon"
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "van-popup",
                  {
                    attrs: { position: "bottom" },
                    model: {
                      value: _vm.selectGender,
                      callback: function($$v) {
                        _vm.selectGender = $$v
                      },
                      expression: "selectGender"
                    }
                  },
                  [
                    _c("van-picker", {
                      attrs: {
                        columns: _vm.columnsGender,
                        "default-index": 0,
                        "show-toolbar": ""
                      },
                      on: {
                        confirm: _vm.onChangeGender,
                        cancel: function($event) {
                          _vm.selectGender = false
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "van-cell",
              {
                attrs: {
                  title: "客户类型",
                  "title-class": "van-cell--required"
                }
              },
              [
                _c(
                  "van-field",
                  {
                    staticClass: "item2",
                    attrs: { placeholder: "请选择客户类型", readonly: "" },
                    on: {
                      click: function() {
                        return (_vm.selectCustType = true)
                      }
                    },
                    model: {
                      value: _vm.traffic.customerType,
                      callback: function($$v) {
                        _vm.$set(_vm.traffic, "customerType", $$v)
                      },
                      expression: "traffic.customerType"
                    }
                  },
                  [
                    _c("img", {
                      staticClass: "uparrow",
                      attrs: {
                        slot: "right-icon",
                        src: require("@/assets/img/uparrow.png"),
                        alt: "",
                        srcset: ""
                      },
                      slot: "right-icon"
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "van-popup",
                  {
                    attrs: { position: "bottom" },
                    model: {
                      value: _vm.selectCustType,
                      callback: function($$v) {
                        _vm.selectCustType = $$v
                      },
                      expression: "selectCustType"
                    }
                  },
                  [
                    _c("van-picker", {
                      attrs: {
                        columns: _vm.columnsCustType,
                        "show-toolbar": "",
                        "default-index": 0
                      },
                      on: {
                        confirm: _vm.onChangeCustType,
                        cancel: function($event) {
                          _vm.selectCustType = false
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "van-cell",
              {
                attrs: {
                  title: "客户人数",
                  "title-class": "van-cell--required"
                }
              },
              [
                _c("van-field", {
                  staticClass: "item2",
                  attrs: { type: "number", placeholder: "请输客户人数" },
                  model: {
                    value: _vm.traffic.visitCnt,
                    callback: function($$v) {
                      _vm.$set(_vm.traffic, "visitCnt", $$v)
                    },
                    expression: "traffic.visitCnt"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "van-cell",
              {
                attrs: {
                  title: "到店时间",
                  "title-class": "van-cell--required"
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "flex" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "flex item1",
                        on: {
                          click: function($event) {
                            _vm.showDateTime1 = !_vm.showDateTime1
                          }
                        }
                      },
                      [
                        _vm.traffic.dateFrom
                          ? _c("p", { staticClass: "item1 date-time black" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm._f("getTime")(_vm.traffic.dateFrom)
                                  ) +
                                  "\n            "
                              )
                            ])
                          : _c("p", { staticClass: "item1 date-time" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s("请选择") +
                                  "\n            "
                              )
                            ]),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "triangle_border_down",
                          attrs: { slot: "right-icon" },
                          slot: "right-icon"
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "van-popup",
                      {
                        attrs: { position: "bottom" },
                        model: {
                          value: _vm.showDateTime1,
                          callback: function($$v) {
                            _vm.showDateTime1 = $$v
                          },
                          expression: "showDateTime1"
                        }
                      },
                      [
                        _c("van-picker", {
                          attrs: {
                            columns: _vm.columnsTime,
                            "show-toolbar": ""
                          },
                          on: {
                            confirm: _vm.getFirstDate,
                            cancel: function($event) {
                              _vm.showDateTime1 = !_vm.showDateTime1
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "date-time-seperate" }, [
                      _c("span", [_vm._v(" 至 ")])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "flex item1",
                        on: {
                          click: function($event) {
                            _vm.showDateTime2 = !_vm.showDateTime2
                          }
                        }
                      },
                      [
                        _vm.traffic.dateTo
                          ? _c("p", { staticClass: "item1 date-time black" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm._f("getTime")(_vm.traffic.dateTo)
                                  ) +
                                  "\n            "
                              )
                            ])
                          : _c("p", { staticClass: "item1 date-time" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s("请选择") +
                                  "\n            "
                              )
                            ]),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "triangle_border_down",
                          attrs: { slot: "right-icon" },
                          slot: "right-icon"
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "van-popup",
                      {
                        attrs: { position: "bottom" },
                        model: {
                          value: _vm.showDateTime2,
                          callback: function($$v) {
                            _vm.showDateTime2 = $$v
                          },
                          expression: "showDateTime2"
                        }
                      },
                      [
                        _c("van-picker", {
                          attrs: {
                            columns: _vm.columnsTime,
                            "show-toolbar": ""
                          },
                          on: {
                            confirm: _vm.getLastDate,
                            cancel: function($event) {
                              _vm.showDateTime2 = !_vm.showDateTime2
                            }
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "van-cell",
              {
                attrs: {
                  title: "年龄区间",
                  "title-class": "van-cell--required"
                }
              },
              [
                _c(
                  "van-field",
                  {
                    staticClass: "item2",
                    attrs: { placeholder: "请选择年龄区间", readonly: "" },
                    on: {
                      click: function() {
                        return (_vm.selectAgeRange = true)
                      }
                    },
                    model: {
                      value: _vm.traffic.estimateAge,
                      callback: function($$v) {
                        _vm.$set(_vm.traffic, "estimateAge", $$v)
                      },
                      expression: "traffic.estimateAge"
                    }
                  },
                  [
                    _c("img", {
                      staticClass: "uparrow",
                      attrs: {
                        slot: "right-icon",
                        src: require("@/assets/img/uparrow.png"),
                        alt: "",
                        srcset: ""
                      },
                      slot: "right-icon"
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "van-popup",
                  {
                    attrs: { position: "bottom" },
                    model: {
                      value: _vm.selectAgeRange,
                      callback: function($$v) {
                        _vm.selectAgeRange = $$v
                      },
                      expression: "selectAgeRange"
                    }
                  },
                  [
                    _c("van-picker", {
                      attrs: {
                        columns: _vm.columnsAgeRange,
                        "default-index": 0,
                        "show-toolbar": ""
                      },
                      on: {
                        confirm: _vm.onChangeAgeRange,
                        cancel: function($event) {
                          _vm.selectAgeRange = false
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "van-cell",
              {
                attrs: {
                  title: "所在城市",
                  "title-class": "van-cell--required"
                }
              },
              [
                _c("div", { staticClass: "basic-models-list-item" }, [
                  _c(
                    "div",
                    {
                      staticClass: "region flex",
                      on: {
                        click: function($event) {
                          return _vm.downSelections(11)
                        }
                      }
                    },
                    [
                      _c("span", [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.traffic.provinceName || "请选择") +
                            "\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "uparrow",
                        attrs: {
                          src: require("@/assets/img/uparrow.png"),
                          alt: "",
                          srcset: ""
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "region flex",
                      on: {
                        click: function($event) {
                          _vm.traffic.province ? _vm.downSelections(12) : ""
                        }
                      }
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.traffic.cityName || "请选择"))
                      ]),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "uparrow",
                        attrs: {
                          src: require("@/assets/img/uparrow.png"),
                          alt: "",
                          srcset: ""
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "van-popup",
                  {
                    attrs: { position: "bottom" },
                    model: {
                      value: _vm.showDownSelection,
                      callback: function($$v) {
                        _vm.showDownSelection = $$v
                      },
                      expression: "showDownSelection"
                    }
                  },
                  [
                    _c("van-picker", {
                      staticClass: "van-picker-li",
                      attrs: {
                        "show-toolbar": "",
                        title: "",
                        columns: _vm.downSelection,
                        "value-key": "name"
                      },
                      on: {
                        cancel: _vm.onCancelCode,
                        confirm: _vm.onConfirmCode
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("van-switch-cell", {
              attrs: {
                title: "是否试机",
                "active-color": "#ff4040",
                "inactive-color": "#000000",
                "active-value": "1",
                "inactive-value": "0",
                "title-class": "van-cell--required"
              },
              model: {
                value: _vm.traffic.test,
                callback: function($$v) {
                  _vm.$set(_vm.traffic, "test", $$v)
                },
                expression: "traffic.test"
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.traffic.test === "1",
                    expression: "traffic.test === '1'"
                  }
                ]
              },
              [
                _c(
                  "van-cell-group",
                  { attrs: { title: "试机产品" } },
                  [
                    _c(
                      "van-checkbox-group",
                      {
                        staticClass: "products flex",
                        model: {
                          value: _vm.choosenTried,
                          callback: function($$v) {
                            _vm.choosenTried = $$v
                          },
                          expression: "choosenTried"
                        }
                      },
                      _vm._l(_vm.products, function(item) {
                        return _c(
                          "div",
                          { key: item.value, staticClass: "products-items" },
                          [
                            _c(
                              "van-checkbox",
                              {
                                attrs: {
                                  name: item.value,
                                  title: item.name,
                                  "checked-color": "#ff4040"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(item.name) +
                                    "\n              "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      }),
                      0
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("van-switch-cell", {
              attrs: {
                title: "是否购买",
                "active-color": "#ff4040",
                "inactive-color": "#000000",
                "active-value": "1",
                "inactive-value": "0",
                "title-class": "van-cell--required"
              },
              model: {
                value: _vm.traffic.buy,
                callback: function($$v) {
                  _vm.$set(_vm.traffic, "buy", $$v)
                },
                expression: "traffic.buy"
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.traffic.buy === "1",
                    expression: "traffic.buy === '1'"
                  }
                ]
              },
              [
                _c(
                  "van-cell-group",
                  { attrs: { title: "购机产品" } },
                  [
                    _c(
                      "van-checkbox-group",
                      {
                        staticClass: "products flex",
                        model: {
                          value: _vm.choosenBought,
                          callback: function($$v) {
                            _vm.choosenBought = $$v
                          },
                          expression: "choosenBought"
                        }
                      },
                      _vm._l(_vm.products, function(item) {
                        return _c(
                          "div",
                          { key: item.value, staticClass: "products-items" },
                          [
                            _c(
                              "van-checkbox",
                              {
                                attrs: {
                                  name: item.value,
                                  title: item.name,
                                  "checked-color": "#ff4040"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(item.name) +
                                    "\n              "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      }),
                      0
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.traffic.buy !== "1",
                    expression: "traffic.buy !== '1'"
                  }
                ]
              },
              [
                _c(
                  "van-panel",
                  {
                    staticClass: "panel-margin",
                    attrs: { title: "未成交原因" }
                  },
                  [
                    _c("van-field", {
                      staticClass: "item2",
                      attrs: {
                        type: "textarea",
                        placeholder: "请输入未成交原因"
                      },
                      model: {
                        value: _vm.traffic.reason,
                        callback: function($$v) {
                          _vm.$set(_vm.traffic, "reason", $$v)
                        },
                        expression: "traffic.reason"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "van-panel",
              { staticClass: "panel-margin", attrs: { title: "备注" } },
              [
                _c("van-field", {
                  staticClass: "item2",
                  attrs: { type: "textarea", placeholder: "请输入备注" },
                  model: {
                    value: _vm.traffic.remark,
                    callback: function($$v) {
                      _vm.$set(_vm.traffic, "remark", $$v)
                    },
                    expression: "traffic.remark"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "bottom-btn flex" }, [
          _c(
            "div",
            { staticClass: "item1 btn save", on: { click: _vm.cancelEdit } },
            [_vm._v("取消")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "item1 btn sub",
              on: {
                click: function($event) {
                  return _vm.saveTraffic()
                }
              }
            },
            [_vm._v("保存")]
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-efe66ad4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-efe66ad4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/client/childCompoents/editCustomerTraffic.vue
// module id = null
// module chunks = 